export const IconGrayHelpKnowledgeQuestion40: {
  name: 'icon_gray_help_knowledge_question_40-377d7ff6ad99'
} = {
  name: 'icon_gray_help_knowledge_question_40-377d7ff6ad99'
}
